import React, { useEffect, useState } from 'react'
import { Text, Box, Flex, Button, DropdownMenu, IconButton, Avatar, Spinner } from '@radix-ui/themes'
import { BellIcon, DotFilledIcon } from '@radix-ui/react-icons'
import { useDispatch, useSelector } from 'react-redux'
import { notificationService } from '../../services/notificationService'
import { updateNotifications } from '../../redux/slices/userSlice'
import { useNavigate } from 'react-router-dom'
import { DateTime } from 'luxon'


const NotificationsList = () => {
    const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const notifications = useSelector((state) => state.user.notifications);
    // console.log('notifications:', notifications);
    const unreadCount = notifications.filter(notification => !notification.read_at).length;
    const [loading, setLoading] = useState(false);

    const getInitialNotifications = async () => {
        setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1000));// Simulate a delay
        try {
            const response = await notificationService.getInitialNotifications();
            // console.log('INITAL NOTIFICATIONS response', response);
            dispatch(updateNotifications(response));
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const getUnreadNotifications = async () => {
        setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1000));// Simulate a delay
        try {
            const response = await notificationService.getUnreadNotifications();
            dispatch(updateNotifications([...notifications, ...response]));
            // console.log('UNREAD NOTIFICATIONS response', response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }



    useEffect(() => {
        const interval = setInterval(() => {
            getUnreadNotifications();
        }, 50000); // 1 minute interval
        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    useEffect(() => {
        const handleFocus = () => {
            getInitialNotifications();
        };

        window.addEventListener('focus', handleFocus);
        return () => window.removeEventListener('focus', handleFocus);
    }, []);


    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger>
                <IconButton variant="soft" size="2" width="50">
                    {loading ? (<Spinner size="1" />) : (<BellIcon width="16" height="16" />)}
                    {unreadCount > 0 && (
                        <Text>{unreadCount}</Text>
                    )}
                </IconButton>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content style={{ width:'100%', maxWidth: '350px' }}>
              {notifications.length > 0 ? (
                notifications.map((notification, index) => (
                  <DropdownMenu.Item
                    key={index}
                    className="cursor-pointer"
                    style={{ height: 'auto' }}
                    onClick={() => {
                      if (notification.data.url) {
                        navigate(notification.data.url); // Navigate to the URL if it exists
                      }
                    }}
                  >
                    <Flex gap="2" py="2" align="center">
                      <Box style={{ position: 'relative', width: '40px', height: '40px' }}>
                        <Avatar
                          src={`${PUBLIC_URL}/storage/${notification.data.image}`}
                          fallback="ed"
                        />
                        {!notification.read_at && (
                          <DotFilledIcon
                            width="40"
                            height="40"
                            color="green"
                            style={{ position: 'absolute', top: '-18px', left: '-18px' }}
                          />
                        )}
                      </Box>
                      <Flex direction="column" align="start">
                        <Flex gap="2" justify="start" align="center">
                          <Text size="1" weight="bold" as="p">
                            {notification.data.title}
                          </Text>
                          <Text size="1" as="p">
                            {DateTime.fromISO(notification.created_at).toRelative()}
                          </Text>
                        </Flex>
                        <Text size="1" as="p">{notification.data.message}</Text>
                      </Flex>
                    </Flex>
                  </DropdownMenu.Item>
                ))
              ) : (
                <DropdownMenu.Item disabled>No notifications</DropdownMenu.Item>
              )}
              <Text
                size="1"
                as="p"
                className="cursor-pointer"
                style={{ textAlign: 'center', padding: '8px 0', alignSelf: 'flex-start' }}
              >
                See all notifications
              </Text>
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    )
}

export default NotificationsList;